export default {
  REQUEST_LOGIN: 'REQUEST_LOGIN',
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  LOGIN_ERROR: 'LOGIN_ERROR',
  RESET_AUTH: 'RESET_AUTH',
  LOGOUT: 'LOGOUT'
}
